/**
 * TEMPORARY (SC-129165). Measures how many attributions the Cloudflare
 * challenge referrer restoration actually rescues, and which sources they came
 * from, so we can tell a partial recovery in SEO Non-Branded from the fix
 * underperforming. Delete this module, its caller in restoreReferrer.ts, and the
 * `/_beacon/` short circuit in nextServer.js once we have a stable read.
 *
 * The beacon is logged by requestLogger, which runs before routing, so no
 * logging changes are needed. Its own `Referer` header carries the page it fired
 * from, and Cloudflare's ja4 / bot_score / verified_bot ride along on the same
 * request, so bot traffic can be excluded at query time.
 */
// Sits under /_next because that prefix already routes to the grailed-next-js
// cluster, so this needs no goat-services route config. nextServer.js answers
// it before Next sees the path, and Next owns no `_beacon` path of its own.
const BEACON_PATH = "/_next/_beacon/referrer-restoration";

// Segment middleware runs per event, so a single challenged page load would
// otherwise report several times over.
let hasReported = false;

/**
 * Only the host, never the full referrer — referrer query strings can carry
 * PII, and this value lands in our logs verbatim. Host is enough to tell which
 * sources are being rescued.
 */
const hostOf = (referrer: string): string => {
  try {
    return new URL(referrer).host;
  } catch {
    return "unparsable";
  }
};

export const reportReferrerRestoration = (
  serverReferrer: string | null | undefined,
): void => {
  if (hasReported) return;
  if (typeof navigator.sendBeacon !== "function") return;

  hasReported = true;

  const params = new URLSearchParams({
    outcome: serverReferrer ? "restored" : "unrecoverable",
    referrerHost: serverReferrer ? hostOf(serverReferrer) : "none",
  });

  navigator.sendBeacon(`${BEACON_PATH}?${params}`);
};
